import { createFileRoute } from "@tanstack/react-router";
import ThankYou from "@/pages/site/ThankYou";

export const Route = createFileRoute("/thank-you")({
  component: () => <ThankYou />,
});
